"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountDashboardProtocols = exports.Currencies = exports.AccountProofStates = exports.AccountMemberStores = exports.AccountMemberStates = exports.AccountMemberTypes = exports.AccountStores = exports.AccountStates = exports.AccountTypes = void 0;
var AccountTypes;
(function (AccountTypes) {
    AccountTypes["Contract"] = "Contract";
    AccountTypes["Key"] = "Key";
})(AccountTypes = exports.AccountTypes || (exports.AccountTypes = {}));
var AccountStates;
(function (AccountStates) {
    AccountStates["UnDeployed"] = "UnDeployed";
    AccountStates["Deployed"] = "Deployed";
})(AccountStates = exports.AccountStates || (exports.AccountStates = {}));
var AccountStores;
(function (AccountStores) {
    AccountStores["PersonalAccountRegistry"] = "PersonalAccountRegistry";
})(AccountStores = exports.AccountStores || (exports.AccountStores = {}));
var AccountMemberTypes;
(function (AccountMemberTypes) {
    AccountMemberTypes["Owner"] = "Owner";
})(AccountMemberTypes = exports.AccountMemberTypes || (exports.AccountMemberTypes = {}));
var AccountMemberStates;
(function (AccountMemberStates) {
    AccountMemberStates["Added"] = "Added";
    AccountMemberStates["Removed"] = "Removed";
})(AccountMemberStates = exports.AccountMemberStates || (exports.AccountMemberStates = {}));
var AccountMemberStores;
(function (AccountMemberStores) {
    AccountMemberStores["AccountOwnerRegistry"] = "AccountOwnerRegistry";
    AccountMemberStores["PersonalAccountRegistry"] = "PersonalAccountRegistry";
})(AccountMemberStores = exports.AccountMemberStores || (exports.AccountMemberStores = {}));
var AccountProofStates;
(function (AccountProofStates) {
    AccountProofStates["Added"] = "Added";
    AccountProofStates["Removed"] = "Removed";
})(AccountProofStates = exports.AccountProofStates || (exports.AccountProofStates = {}));
var Currencies;
(function (Currencies) {
    Currencies["USD"] = "USD";
    Currencies["EUR"] = "EUR";
    Currencies["GBP"] = "GBP";
})(Currencies = exports.Currencies || (exports.Currencies = {}));
var AccountDashboardProtocols;
(function (AccountDashboardProtocols) {
    AccountDashboardProtocols["Investments"] = "Investments";
    AccountDashboardProtocols["LiquidityPools"] = "LiquidityPools";
    AccountDashboardProtocols["Deposits"] = "Deposits";
    AccountDashboardProtocols["Rewards"] = "Rewards";
})(AccountDashboardProtocols = exports.AccountDashboardProtocols || (exports.AccountDashboardProtocols = {}));
